import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from './Navbar';
import MysticalParticles from './MysticalParticles';

const ComingSoon = () => {
  return (
    <div className="min-h-screen flex flex-col relative">
      {/* Magical Background */}
      <div className="fixed inset-0 -z-10">
        <img 
          src="https://cdn.4fingerstudios.com/Mystveil/Mystveil_map.png" 
          alt="Mystveil Township Map" 
          className="w-full h-full object-cover opacity-30 blur-sm" 
        />
        <div className="absolute inset-0 bg-gradient-to-br from-purple-900/20 via-pink-900/20 to-purple-900/20"></div>
      </div>

      {/* Magical Particles */}
      <MysticalParticles />

      {/* Navigation */}
      <Navbar />

      {/* Main Content */}
      <main className="flex-grow flex items-center justify-center px-4 py-8">
        <div className="max-w-4xl mx-auto text-center">
          <div className="mystical-card">
            <h1 className="mystical-title text-black mb-8">
              Coming Soon!
            </h1>
            
            <div className="mystical-card bg-white bg-opacity-95 mb-8">
              <span className="mystical-title text-purple-600 text-6xl mb-6 block">
                Mystveil Township
              </span>
              <p className="mystical-text text-black text-2xl">
                New adventures await in the mist...
              </p>
            </div>

            {/* Navigation Buttons */}
            <div className="flex flex-wrap justify-center gap-4">
              <Link to="/" className="mystical-button">
                Return Home
              </Link>
              <Link to="/guide" className="mystical-button">
                View Guides
              </Link>
              <Link to="/news" className="mystical-button">
                Latest News
              </Link>
            </div>
          </div>
        </div>
      </main>

      {/* Mystical Footer */}
      <footer className="mystical-nav py-6 mt-auto">
        <div className="container mx-auto px-4 text-center">
          <p className="mystical-text font-bold">
            © 2025 4fingerstudios <br /> 
            © 2024 Reckless Dreams. All Rights Reserved.
          </p>
        </div>
      </footer>
    </div>
  );
};

export default ComingSoon;